// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__4UclP","line":"default_line__Ui5hC","left":"default_left__NI3cQ","right":"default_right__9T4qu"};